document.addEventListener(
    'DOMContentLoaded',
    () => {
        setTimeout(() => {
            window.createUpsellButtons();
        });
    },
    false,
);

window.createUpsellButtons = () => {
    // check global loading...
    // window.sellsyapp.config.globalProperties.$store.state.system.globalLoading

    if (
        !window.sellsyapp ||
        window.sellsyapp?.config.globalProperties.$store?.state?.system.globalLoading
    ) {
        setTimeout(() => {
            window.createUpsellButtons();
        }, 100);
    } else {
        MyFacture.startWait();

        const upsellButtons = document.querySelectorAll('[data-upsell]');

        const featureStore =
            window.sellsyapp?.config.globalProperties.$store.state.subscriptionFeatures;

        if (featureStore) {
            const deactivatedFeatures = Object.keys(
                Object.fromEntries(Object.entries(featureStore).filter(([key, value]) => !value)),
            );

            for (const item of upsellButtons) {
                if (
                    deactivatedFeatures.includes(item.dataset.upsell) &&
                    !item.classList.contains('upsell-action')
                ) {
                    // clones node and removes all listeners
                    const clone = item.cloneNode(true);
                    if (clone.getAttribute('onclick')) {
                        clone.removeAttribute('onclick');
                    }
                    if (clone.getAttribute('href')) {
                        clone.removeAttribute('href');
                    }

                    clone.classList.add('upsell-action');

                    const featureBadge = document.querySelector('#featureBadge').cloneNode(true);
                    featureBadge.removeAttribute('style');
                    featureBadge.removeAttribute('id');

                    clone.appendChild(featureBadge);

                    clone.addEventListener('click', () => {
                        window.sellsyapp.config.globalProperties.$store.state.popupPanel.featureModal.props =
                            {
                                feature: item.dataset.upsell,
                            };
                        window.sellsyapp.config.globalProperties.$store.state.popupPanel.featureModal.display = true;
                    });

                    item.replaceWith(clone);
                }
            }
        }

        MyFacture.stopWait();
    }
};
